import React from "react";
import { webDevelopmentData } from "../data/software-apps";
import WebDevelopmentIcon from "../icons/web-development";

const WebDevelopment = () => {
  return (
    <div className="row align-items-center" id="web-development">
      <div className="col-12 col-lg-6 text-center text-lg-start">
        <WebDevelopmentIcon />
        <h2 className="fs-56 lh-64 text-danger gilroy-bold py-5">
          Web development
        </h2>
        <p className="fs-16 text-align-justify">
          Web development Our site designers give master web application
          advancement and web plan administrations to our clients. We offers a
          assortment of site plan and advancement administrations, from making
          versatile web improvement arrangements and responsive site plans, to
          building custom e-commerce and intranet encounters utilizing the most
          recent and demonstrated web advances. With up to 85% of shoppers going
          by company’s or benefit provider’s site some time recently making a
          buy, increasingly buyers make choices based on their online
          involvement: the appearance, convenience and openness of your site is
          more critical than ever, particularly in an progressively competitive
          advertise.
        </p>
      </div>
      <div className="col-12 col-lg-6">
        <div className="row">
          <div className="col-12 col-md-6">
            {webDevelopmentData.slice(0, 2).map((info) => (
              <div
                key={info.title}
                className="text-center digital-card border px-4 py-5 my-4 rounded"
              >
                <img
                  src={info.img}
                  alt={info.title}
                  className="img-fluid software-and-apps-img card-design-2"
                />
                <h3 className="gilroy-bold mt-4">{info.title}</h3>
              </div>
            ))}
          </div>
          <div className="col-12 col-md-6 mt-0 mt-md-5">
            {webDevelopmentData.slice(2, 4).map((info) => (
              <div
                key={info.title}
                className="text-center digital-card border px-4 py-5 mb-4 rounded"
              >
                <img
                  src={info.img}
                  alt={info.title}
                  className="img-fluid software-and-apps-img card-design-2"
                />
                <h3 className="gilroy-bold mt-4">{info.title}</h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebDevelopment;
